////////EF 6.1 schema
const sixOneSchema = {
  title: "6_1 Indirect GHG Emissions from other sources",
  cat: "6_1",
  catName: "cat6",
  progressiveOrderSwitch: {},
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown6_1",
      autoFillNum: 0,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 2,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat6CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default sixOneSchema;
